<template>
  <v-app-bar
    max-height="48"
    class="px-0 gradiente-topo"
    dense
    dark
    app
    style="border-radius: 0;"
  >
    <div
      class="d-flex flex-no-wrap align-center"
      style="width: 100%;"
    >
      <v-btn
        icon
        small
        class="ml-0 mr-3 flex-shrink-0"
        data-cy="button_fechar_modal"
        :to="urlBtnFechar"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-toolbar-title
        v-if="load"
        class="text-truncate body-2 d-block"
        data-cy="titulo_modal"
      >
        {{ tituloModal }}
      </v-toolbar-title>
    </div>
  </v-app-bar>
</template>

<script>

export default {
  name: 'TopoModal',

  props: {
    tituloModal: {
      type: String,
      default: '',
    },
    urlBtnFechar: {
      type: String,
      required: true,
    },
  },

  computed: {
    load() {
      return !!this.tituloModal;
    },
  },
};
</script>
